__turbopack_context__.v({
  "categoriesListWrapper": "styles-module-scss-module__VeDNbq__categoriesListWrapper",
  "heroBannerTitle": "styles-module-scss-module__VeDNbq__heroBannerTitle",
  "link": "styles-module-scss-module__VeDNbq__link",
  "notation": "styles-module-scss-module__VeDNbq__notation",
  "sberLogo": "styles-module-scss-module__VeDNbq__sberLogo",
  "section": "styles-module-scss-module__VeDNbq__section",
  "sectionTitle": "styles-module-scss-module__VeDNbq__sectionTitle",
});
